import { render, staticRenderFns } from "./ProvinceCreateOrUpdate.vue?vue&type=template&id=097103eb&"
import script from "./ProvinceCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./ProvinceCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports